"use strict";

exports.__esModule = true;
var _ToggleButton = _interopRequireDefault(require("./ToggleButton"));
exports.default = _ToggleButton.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}